// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n0Cm","right":"styles_right__3Rppo"};